import { Role } from '@precon-tools-suite-by-shared/js-precon-rbac';
import type { RouteRecordRaw } from 'vue-router';
import { AbilityContext } from '@precon-tools-suite-by-shared/shared-auth-js-ability-checks';

export default [
    {
        path: '/maintenance',
        name: 'maintenance',
        component: () => import('./pages/Index.vue'),
        meta: {
            layout: 'app',
            policy: (context: AbilityContext) => {
                const ability = (context: AbilityContext) => {
                    return context.hasRole(Role.MAINTAINER);
                };

                return context.check(ability);
            },
        },
    },
] satisfies RouteRecordRaw[];
